module.exports = "/_next/static/images/cell_1-229e6e03b406d1409ba652d1da6dc19f.png";